import { each } from 'lodash';
import { BLOCKED_UPLOAD_ERROR_CODE } from '../constants';
import { postError } from '../api/uploadApi';

export default function mapBackendErrorsToUserFields(errors, uniqueIndex = '') {
  const errorMap = {};
  each(errors, (code) => {
    let field;
    switch (code) {
      case 'lerror_124':
      case 'lerror_125':
      case `lerror_83${uniqueIndex}`:
      case `lerror_84${uniqueIndex}`:
        field = 'firstNameEn';
        break;
      case 'lerror_126':
      case 'lerror_127':
      case `lerror_85${uniqueIndex}`:
      case `lerror_86${uniqueIndex}`:
        field = 'lastNameEn';
        break;
      case 'lerror_1':
      case 'lerror_2':
      case `lerror_89${uniqueIndex}`:
      case `lerror_90${uniqueIndex}`:
      case '0094':
      case '0196':
      case 'verror_insert_firstname':
        field = 'firstName';
        break;
      case 'lerror_3':
      case `lerror_91${uniqueIndex}`:
      case `lerror_92${uniqueIndex}`:
      case 'lerror_4':
      case '0197':
      case 'verror_insert_lastname':
        field = 'lastName';
        break;
      case 'lerror_5':
      case 'lerror_6':
      case `lerror_93${uniqueIndex}`:
      case `lerror_94${uniqueIndex}`:
      case '0107':
      case '0112':
      case '0114':
      case 'verror_insert_gender':
        field = 'gender';
        break;
      case 'lerror_7':
      case 'lerror_8':
      case `lerror_95${uniqueIndex}`:
      case `lerror_96${uniqueIndex}`:
      case `lerror_128${uniqueIndex}`:
      case 'lerror_130':
      case 'lerror_144':
      case '0102':
      case '0103':
      case '0198':
      case 'verror_insert_birthday':
      case 'verror_invalid_birthday':
      case 'verror_invalid_birthday_signer':
        field = 'birthday';
        break;
      case 'lerror_9':
      case 'lerror_10':
      case `lerror_97${uniqueIndex}`:
      case `lerror_98${uniqueIndex}`:
      case '0034':
      case '0035':
      case '0036':
      case '0043':
      case '0101':
      case '0176':
      case '0177':
      case '0179':
      case '0180':
      case '0181':
      case 'verror_invalid_socialcard':
      case 'verror_invalid_socialcardnum':
      case 'verror_invalid_socialcardnum12':
      case 'verror_invalid_socialcardnum34':
      case 'verror_invalid_socialcardnum56':
      case 'verror_invalid_socialcardnum789':
      case 'verror_invalid_socialcardnum10':
        field = 'socCard';
        break;
      case 'lerror_13':
      case 'lerror_14':
      case `lerror_101${uniqueIndex}`:
      case `lerror_102${uniqueIndex}`:
      case '0024':
      case '0092':
      case '0199':
      case '0200':
      case 'verror_insert_passportnum':
      case 'verror_invalid_passportlength':
      case 'verror_invalid_passportseriya':
      case 'verror_invalid_passportnum':
        field = 'passport';
        break;
      case 'lerror_15':
      case 'lerror_16':
      case `lerror_103${uniqueIndex}`:
      case `lerror_104${uniqueIndex}`:
      case '0097':
      case '0098':
      case 'verror_insert_issuedate':
      case 'verror_invalid_issuedate':
        field = 'passportGiven';
        break;
      case 'lerror_17':
      case 'lerror_18':
      case `lerror_105${uniqueIndex}`:
      case `lerror_106${uniqueIndex}`:
      case '0099':
      case 'verror_insert_expirydate':
      case 'verror_invalid_expirydate':
        field = 'passportValidUntil';
        break;
      case 'lerror_19':
      case 'lerror_20':
      case `lerror_107${uniqueIndex}`:
      case `lerror_108${uniqueIndex}`:
      case '0095':
      case '0096':
      case 'verror_insert_authority':
        field = 'passportFrom';
        break;
      case 'lerror_11':
      case 'lerror_12':
      case `lerror_99${uniqueIndex}`:
      case `lerror_100${uniqueIndex}`:
      case '0100':
      case '0133':
      case '0134':
      case '0163':
      case '0164':
        field = 'citizenship';
        break;
      case 'lerror_21':
      case 'lerror_22':
      case `lerror_109${uniqueIndex}`:
      case `lerror_110${uniqueIndex}`:
      case '0123':
      case '0153':
      case 'verror_insert_resident':
        field = 'resident';
        break;
      case 'lerror_31':
      case 'lerror_32':
      case '0116':
      case '0147':
      case 'verror_insert_phone_or_mobphone':
        field = 'cellPhone';
        break;
      case 'lerror_29':
      case 'lerror_30':
      case `lerror_112${uniqueIndex}`:
      case `lerror_113${uniqueIndex}`:
      case '0115':
      case '0146':
      case 'verror_insert_phone':
        field = 'phone';
        break;
      case 'lerror_33':
      case 'lerror_34':
      case 'lerror_69':
      case 'lerror_70':
      case '0032':
      case '0033':
      case '0117':
        field = 'email';
        break;
      case 'lerror_35':
      case 'lerror_36':
      case `lerror_116${uniqueIndex}`:
      case `lerror_117${uniqueIndex}`:
      case '0118':
      case '0148':
      case '0210':
      case 'verror_insert_country':
        field = 'country';
        break;
      case 'lerror_37':
      case 'lerror_38':
      case `lerror_118${uniqueIndex}`:
      case `lerror_119${uniqueIndex}`:
      case '0119':
      case '0120':
      case '0149':
      case '0150':
      case 'verror_insert_region':
        field = 'state';
        break;
      case 'lerror_39':
      case 'lerror_40':
      case `lerror_120${uniqueIndex}`:
      case `lerror_121${uniqueIndex}`:
      case '0121':
      case '0122':
      case '0151':
      case '0152':
      case '0208':
      case 'verror_insert_city':
        field = 'cityVillage';
        break;
      case 'lerror_41':
      case 'lerror_42':
      case `lerror_122${uniqueIndex}`:
      case `lerror_123${uniqueIndex}`:
      case '0124':
      case '0125':
      case '0126':
      case '0127':
      case '0128':
      case '0129':
      case '0130':
      case '0132':
      case '0154':
      case '0155':
      case '0156':
      case '0157':
      case '0158':
      case '0159':
      case '0160':
      case '0161':
      case '0162':
      case 'verror_insert_add_loc':
      case 'verror_insert_location':
        field = 'street';
        break;
      case `lerror_87${uniqueIndex}`:
      case `lerror_88${uniqueIndex}`:
      case `lerror_41${uniqueIndex}`:
      case `lerror_42${uniqueIndex}`:
        field = 'street';
        break;
      default:
        break;
    }

    if (field) {
      errorMap[field] = code;
    }
  });

  return errorMap;
}

export function mapBackendErrorsToCalculatorFields(errors) {
  const errorMap = {};
  each(errors, (code) => {
    let field;
    switch (code) {
      case 'lerror_23':
      case 'lerror_24':
      case 'lerror_25':
      case '0001':
      case '0012':
      case '0013':
      case '0014':
      case '0166':
      case '0167':
      case '0168':
      case '0169':
      case '0170':
      case '0171':
      case '0175':
      case '0212':
      case 'verror_fromdate_not_allowedrange':
      case 'verror_createdate_not_allowedrange':
      case 'verror_invalid_createdate':
      case 'verror_invalid_fromdate':
      case 'verror_fromdate_big_todate':
      case 'verror_waiting_period':
      case 'invalid_allowed_from_date':
      case 'given_date_smaller':
        field = 'start';
        break;
      case 'lerror_26':
      case 'lerror_27':
      case 'lerror_71':
      case '0002':
      case '0011':
      case '0015':
      case '0016':
      case '0029':
      case '0213':
      case '0215':
      case '0216':
      case '0217':
      case '0218':
      case 'verror_todate_not_allowedrange':
      case 'verror_invalid_todate':
      case 'verror_invalid_lastpaymdate':
      case 'verror_invalid_lastpaymdate_small_createdate':
      case 'verror_empty_paym_befordate':
      case 'verror_paym_befordate_not_working':
      case 'invalid_allowed_to_date':
      case 'given_date_greater':
        field = 'end';
        break;
      case 'lerror_76':
        field = 'region';
        break;
      default:
        break;
    }

    if (field) {
      errorMap[field] = code;
    }
  });

  return errorMap;
}

export const handleUploadBackendError = (error, metadata) => {
  const frontendError = {};

  frontendError.type = typeof error;
  frontendError.originalError = error;
  if (error && error.message) {
    frontendError.message = error.message;
  }
  if (error && error.name) {
    frontendError.name = error.name;
  }
  if (error && error.response) {
    frontendError.response = error.response;
  }

  postError(frontendError, metadata).catch(() => {});

  const genericError = 'backendErrors.upload_failed';

  if (!error) {
    return genericError;
  }

  if (error.code === BLOCKED_UPLOAD_ERROR_CODE) {
    return 'backendErrors.upload_blocked';
  }

  let errorCode;
  try {
    // try to extract lerror code from Error object
    // eslint-disable-next-line prefer-destructuring
    errorCode = Object.values(error.response.data.errors)[0][0];
    if (!errorCode.includes('lerror')) {
      throw new Error('unknown type of backend error');
    }
  } catch (e) {
    return genericError;
  }
  return `backendErrors.${errorCode}`;
};
